module.exports = __webpack_public_path__ + "media/svg-new/avatar-8 4-dc0b11cd.svg";